import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['observable']
  static values = { limit: Number, rootMargin: String }

  connect() {
    this.reset()
    this.observablesSet = false
    this.observer = new IntersectionObserver(
      (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            if (this.page >= this.limitValue) {
              if (!this.limitReached) {
                this.dispatch('limit-reached', { detail: { page: this.page } })
                this.limitReached = true
              }
              break
            } else {
              this.page = this.page + 1
              this.dispatch('next-page', { detail: { page: this.page } })
            }
          }
        }
      },
      { rootMargin: this.rootMarginValue }
    )
  }

  startObserving() {
    if (!this.observablesSet) {
      for (let observable of this.observableTargets) {
        this.observer.observe(observable)
      }
      this.observablesSet = true
    }
  }

  reset() {
    this.page = 1
    this.limitReached = false
  }
}
